<template>
  <div class="table-responsive">
    <Table :rows="list" :columns="columns" :columnID="'idItinerario'">
      <template #headactions>
        <button class="btn btn-xs btn-icon btn-light-success" @click="onNew">
          <i class="fa fa-plus"></i>
        </button>
        <button v-if="loading.save" class="btn btn-xs btn-icon btn-link ml-1" :disabled="true" title="Guardando nuevo orden de itinerario">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        </button>
      </template>
      <template #tbody="{ rows }">
        <Draggable v-if="!estaLiquidado" v-model="listDraggable" tag="tbody" handle=".sortable-handle">
          <PrivadoItinerarioRow v-for="row in rows" :key="row.idItinerario" :item="row"></PrivadoItinerarioRow>
        </Draggable>
        <template v-else>
          <PrivadoItinerarioRow v-for="row in rows" :key="row.idItinerario" :item="row"></PrivadoItinerarioRow>
        </template>
      </template>
    </Table>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import PrivadoItinerarioRow from "./PrivadoItinerarioRow.vue";
import Table from "../../shared/components/Table.vue";
import { mapState, mapGetters } from "vuex";
import { debounce } from "@/modules/shared/helpers";

export default {
  components: { Table, PrivadoItinerarioRow, Draggable },
  data() {
    return {
      loading: {
        save: false,
      },
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          key: "fecha",
          label: "Fecha",
          width: 90,
        },
        {
          key: "servicio",
          width: 180,
        },
        {
          key: "proveedor",
          width: 150,
        },
        {
          key: "hotel",
          width: 150,
        },
        {
          key: "vueloTourTren",
          label: "Vuelo-Tour-Tren",
          width: 200,
        },
        {
          key: "guia",
          label: "Guía",
          width: 150,
        },
        {
          key: "servicioSigla",
          label: "Tipo",
          width: 50,
          head_class: "text-center",
        },
        {
          key: "restaurante",
          width: 150,
        },
        {
          key: "observaciones",
          width: 200,
        },
      ];

      if (!this.estaLiquidado) {
        columns.unshift(
          {
            key: "actions",
            label: "",
            width: 60,
            head_class: "text-center",
          },
          {
            key: "handle",
            label: "",
            width: 20,
          }
        );
      }

      return columns;
    },
    listDraggable: {
      get() {
        return this.list;
      },
      set(val) {
        const vm = this;
        vm.$store.commit("privado.itinerario/updateList", val);
        vm.updateOrdenItinerario(val);
      },
    },
    ...mapState("privado.itinerario", ["list", "privado"]),
    ...mapGetters("privado.itinerario", ["estaLiquidado"]),
  },
  methods: {
    onNew() {
      this.$store.dispatch("privado.itinerario/newItem");
    },
    updateOrdenItinerario: debounce(function(rows) {
      const vm = this;
      const itinerary = rows.map((item, index) => {
        return {
          idItinerario: item.idItinerario,
          orden: index + 1,
        };
      });

      vm.loading.save = true;

      vm.axios
        .put(`/privados/${vm.privado.idPrivado}/itinerario/orden`, {
          itinerary,
        })
        .then(() => {
          vm.$toast.fire("", "Nuevo orden actualizado", "success");
        })
        .finally(() => {
          vm.loading.save = false;
        });
    }, 1000),
  },
};
</script>

<style></style>
